import defaultPreloader from 'assets/preloader/default.svg';

import { CommonUtilsContext } from 'contexts/commonUtils';
import { useContext, useMemo } from 'react';
import { ScPreloader } from './styled';

export const Preloader = () => {
  const { brandAssetsData } = useContext(CommonUtilsContext);

  const currentPreloader = useMemo(
    () =>
      brandAssetsData?.preloader
        ? brandAssetsData.preloader.url
        : defaultPreloader,
    [brandAssetsData]
  );

  return (
    <ScPreloader>
      <div className="logo">
        <object
          aria-label="LuckyElf Casino"
          data={currentPreloader}
          height={57}
          width={200}
        />
      </div>
    </ScPreloader>
  );
};
